import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { MainView, SatCoreRegister, VIEW_SELECTION } from 'sat-core';

export default
@inject('contentManager', 'userManager')
@observer
class MainViewOverride extends Component {
  showResources = async (props) => {
    const { contentManager, userManager } = this.props;
    const { resourceIFrameUrl, resourceIFrameUrlStudent } = contentManager;
    const { isStudent } = userManager;
    const resourceUrl = isStudent ? resourceIFrameUrlStudent : resourceIFrameUrl;
    if (resourceUrl !== null) {
      window.open(resourceUrl, '_blank');
    }
  }

  getNavTabs = (props, parent) => {
    const {
      userManager: {
        activePermissionId,
        isStudent,
        isTeacher
      }
    } = this.props;
    const help = parent.renderMenuItem(
      <>
        {isStudent ? 'Help' : 'Support'}
      </>,
      VIEW_SELECTION.RESOURCES,
      { className: 'resources', onClick: () => this.showResources(props) }
    );
    if (activePermissionId?.includes?.('admin')) {
      return help;
    } else if (isTeacher || isStudent) {
      return (
        <>
          {parent.getBaseNavTabs()}
          {help}
        </>
      );
    }
  }

  render() {
    return <MainView {...this.props} getNavTabs={this.getNavTabs} />;
  }
}

SatCoreRegister('MainView', MainViewOverride);
